import styled from "styled-components/macro";

export const ToggleWrapper = styled.button`
  font-size: 2rem;
  cursor: pointer;
  border: none;
  background-color: transparent;
  color: currentColor;

  &:hover {
    filter: brightness(90%);
  }
`;
